import { Component } from '@angular/core';

import { map } from 'rxjs';
import { Router } from '@angular/router';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthService } from '../service/auth/auth-service.service';


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  loginForm = new FormGroup({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required])
  })

  private authService!: AuthService
  private router!: Router
  loading: boolean = true;
  showError: boolean = false;
  invalidLogin: boolean = false;
  loggingIn: boolean = false;
  restrictLogin: boolean = false;
  constructor(authService: AuthService, router: Router) {
    this.authService = authService;
    this.router = router;
    authService.checkAuthStatus().subscribe({
      next: status => {

        if (status === true) {
          router.navigate([""]);
        } else {
          this.loading = false;
        }
      }
    });


  }

  onSubmit() {
    if (this.loginForm.invalid) {
      this.showError = true;
      return;
    }
    this.loggingIn = true;
    this.invalidLogin = false;
    this.authService.login({ username: this.loginForm.value.username!, password: this.loginForm.value.password! }).subscribe({
      next: response => {
        this.router.navigate([""]);
        this.loggingIn = false;
      },
      error: error => {
        if (error.status == 401) {
          this.invalidLogin = true;
        }

        if (error.status == 429) {
          this.restrictLogin = true;
        }

        if (error.status == 423)
        {
          this.restrictLogin = true;
        }
        
        this.loggingIn = false;
      }
    });

  }

}
